import { uploadFiles } from 'legacy/lut/hooks/useFileUpload'

import { AplDocumentTypes } from '../../../models/aplDocument'
import { UPLOAD_DOCUMENTS_ENDPOINT_BASE } from '../configs'
import { TDocumentLanguage, TDocumentsSet, TDocumentsUploadResults } from '../models'

interface IUploadAplDocumentsParameters {
  documents: TDocumentsSet
  effectiveDate: string
  type: AplDocumentTypes
}

export const uploadAplDocuments = async ({
  documents,
  type,
  effectiveDate,
}: IUploadAplDocumentsParameters) => {
  const responses: TDocumentsUploadResults = {
    en: undefined,
    de: undefined,
    es: undefined,
    fr: undefined,
    it: undefined,
    pt: undefined,
  }

  const locales = Object.keys(documents) as TDocumentLanguage[]

  for (const locale of locales) {
    const document = documents[locale]
    if (document) {
      const uploadResult = await uploadFiles({
        endpoint: `${UPLOAD_DOCUMENTS_ENDPOINT_BASE}/${type}/${locale}/${effectiveDate}`,
        filesInfo: [document],
      })

      if (!uploadResult) {
        continue
      }

      if (uploadResult.response.ok) {
        responses[locale] = {
          status: 'success',
          message: 'Success',
        }

        continue
      }

      const error = await uploadResult.response.json()
      responses[locale] = {
        status: 'error',
        message: error.message,
      }
    }
  }

  return responses
}
